export const DEBUG = 'true' === process.env.REACT_APP_SOUNDBOARD_DEBUG
export const CAPTCHA_SITE_KEY = process.env.REACT_APP_CAPTCHA_SITE_KEY
export const APP_DIRECTORY = process.env.REACT_APP_APP_DIRECTORY